import { APP_INITIALIZER, EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { ModalRegistryService } from 'src/app/core/services/navigation/modal-registry.service';

function registerRoleUserModals(registry: ModalRegistryService): () => void {
  return () => {
    registry.register(
      'guest',
      () => import('../components/guest-mode-modal/guest-mode-modal.component').then(m => m.GuestModeModalComponent),
      { cssClass: 'guest-mode-modal', backdropDismiss: false }
    );

    registry.register(
      'signup',
      () => import('../components/signup-modal/signup-modal.component').then(m => m.SignupModalComponent),
      { cssClass: 'auth-modal', backdropDismiss: false }
    );

    registry.register(
      'login',
      () => import('../components/login-modal/login-modal.component').then(m => m.LoginModalComponent),
      { cssClass: 'auth-modal', backdropDismiss: false }
    );

    registry.register(
      'event',
      () => import('../components/event-modal/event-modal.component').then(m => m.EventModalComponent),
      { cssClass: 'event-modal', showBackdrop: true, backdropDismiss: false }
    );

    registry.register(
      'claim-charity',
      () => import('../components/claim-charity/claim-charity.component').then(m => m.ClaimCharityModalComponent),
      { showBackdrop: true, backdropDismiss: false }
    );

    registry.register(
      'claim-business',
      () => import('../components/claim-business/claim-business.component').then(m => m.ClaimBusinessModalComponent),
      { showBackdrop: true, backdropDismiss: false }
    );
  };
}

export function provideRoleUserModals(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: APP_INITIALIZER,
      useFactory: registerRoleUserModals,
      deps: [ModalRegistryService],
      multi: true,
    },
  ]);
}
